import { Action } from '@ngrx/store';

export const STORAGE = '[Storage] Update';

export class Storage implements Action {
    readonly type = STORAGE;
    constructor(readonly payload: string) {}
}
